<template lang="pug">
	.app-core--editable-label.flex-row(:class="{ disabled, custom: useCustomStyles }")
		.display-mode.flex-1(v-if="isEditing === false", @click="isEditing = true", :title="$tCaption('Click to edit')")
			slot
		.edit-mode.flex-1(v-if="isEditing === true")
			slot(name="editor")
</template>

<script>

export default {
	props: ['editing', 'disabled', 'useCustomStyles'],
	data() {
		return {
			isEditing: !!this.editing
		}
	},
	watch: {
		'editing'(v) {
			if (v)
				this.isEditing = v;
		},
		'isEditing'(v) {
			this.$emit('editing', v);
		}
	},
	mounted() {
		this.$emit('editing', this.isEditing);
	},
	methods: {
		release(v) {
			this.isEditing = !!v;
		}
	}
};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";

	.app-core--editable-label {
		.display-mode {
			cursor: pointer;
			position: relative;
		}

		&.disabled {
			pointer-events: none;
			cursor: default;
		}

		&:not(.custom) {
			&:not(.disabled) {
				.display-mode:hover > * {
					text-decoration: underline solid $base-accent 1.5px !important;
					color: $base-accent !important;
				}
			}
		}
	}
</style>
